"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBody = getBody;
exports.releaseIframe = releaseIframe;
exports.exEval = exEval;
exports.getNextBaseZ = getNextBaseZ;
exports.getScroll = getScroll;
exports.hasClass = hasClass;
exports.getNextTabElement = getNextTabElement;

require("core-js/modules/web.timers.js");

require("core-js/modules/es.string.split.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.array.index-of.js");

var _has = _interopRequireDefault(require("./has"));

/**
 * Created by wqw on 2018/1/2.
 */

/* eslint no-cond-assign: 0 ,no-eval:0*/
var body;
var _releaseIframeTimer = null;
var _baseZ = 10000;
var TIMEOUT = 64;
var _releaseIframe = [];

function getBody() {
  if (!body) {
    body = window.jQuery('body');
  }

  return body;
}

function releaseIframe(iframe) {
  _releaseIframe.push(iframe);

  if (_releaseIframeTimer) {
    clearTimeout(_releaseIframeTimer);
  }

  _releaseIframeTimer = setTimeout(releaseIframeDelay, TIMEOUT);
}

function releaseIframeDelay() {
  var iframe;

  while (iframe = _releaseIframe.shift()) {
    iframe.attr({
      src: 'about:blank'
    });
  }

  if ((0, _has["default"])('_isIE')) {
    // eslint-disable-next-line no-useless-catch
    try {
      window.CollectGarbage();
    } catch (exp) {
      throw exp;
    }
  }
}

function exEval(functionNames) {
  var t = functionNames.split(','); // if (!frameName) {
  //   frameName = 'frameContent';
  // }

  for (var i = 0; i < t.length; i++) {
    eval(t[i])();
  }
}

function getNextBaseZ() {
  return _baseZ += 5;
}

function getScroll(el) {
  var scroll = {
    scrollY: false,
    scrollX: false
  };

  if (el.scrollHeight > el.clientHeight) {
    scroll.scrollY = true;
  }

  if (el.offsetHeight - el.clientHeight > 0) {
    scroll.scrollX = true;
  }

  return scroll;
}
/* istanbul ignore next */


function hasClass(el, cls) {
  if (!el || !cls) return false;
  if (cls.indexOf(' ') !== -1) throw new Error('className should not contain space.');

  if (el.classList) {
    return el.classList.contains(cls);
  } else {
    return (' ' + el.className + ' ').indexOf(' ' + cls + ' ') > -1;
  }
}

function getNextTabElement(current, shift) {
  var next;

  while (current) {
    if (!shift) {
      next = current.firstChild || current.nextSibling;

      if (!next) {
        do {
          if ((current = current.parentNode) && current.nodeName === 'BODY') return null;
        } while (!(next = current.nextSibling));
      }
    } else {
      next = current.lastChild || current.previousSibling;

      if (!next) {
        do {
          if ((current = current.parentNode) && current.nodeName === 'BODY') return null;
        } while (!(next = current.previousSibling));
      }
    }

    current = next;
    if (current.nodeName === 'A' || current.nodeName === 'INPUT' || current.nodeName === 'SELECT' || current.nodeName === 'BUTTON' || current.nodeName === 'TEXTAREA') return current;
  }

  return null;
}